// Igrivi izrazi. Vsebina je ločena od komponent, da jo družina lahko preprosto spremeni.
export const copy = {
  tagline: 'Kljukice namesto izgovorov',
  greetings: ['Živjo', 'Hej', 'Pozdravljen(a)'],
  allDone: 'Vse kljukice so na svojem mestu. Kavč te že kliče.',
  emptyDay: 'Danes ni nalog. Sumljivo lep dan.',
  emptyQueue: 'Nič ne čaka. Ali so vsi pridni ali pa nekaj dobro skrivajo.',
  emptyOffers: 'Nihče ničesar ne podarja. Sumljivo tiho.',
  emptyShopping: 'Seznam je prazen. Hladilnik je očitno poln.',
  emptyPolls: 'Ni odprtih glasovanj. Demokracija počiva.',
  emptyWishes: 'Še ni želja. Kam bi šli, če bi lahko kamorkoli?',
  emptyEvents: 'Nič v koledarju. Redka priložnost za dolgčas.',
  emptyLog: 'Dnevnik časa je še prazen. Ura čaka na prvi tik-tak.',
  timerRunning: 'Tik-tak, delaš kot ura',
  timerPaused: 'Premor – čas dremlje in se ne šteje',
  syncing: 'Leti proti oblaku …',
  synced: 'Vse na varnem',
  offline: 'Brez povezave – shranjujem v žep',
  correction: 'Skoraj! Še malo loščila.',
  thresholdReached: 'KAČING! Žepnina je odklenjena.',
  thresholdMissing: (n: number) => `Do praga še ${n} %. Zmoreš!`,
  heroToasts: ['Junak dneva!', 'Prevzeto. Karma +1.', 'Nekdo bo nocoj bolj spočit – hvala.'],
  animalThanks: 'Hvala v imenu vseh tačk, krempljev in brčic.',
  rewardApproved: 'Točke so odšle, zabava prihaja.',
  getWell: 'Hitro se pozdravi! Naloge počakajo, živali pa gredo na oglasno desko.',
  weekClosed: 'Teden je zaključen in zapečaten. Brez naknadnih pogajanj.',
  noPoints: 'Brez točk – samo za lastno evidenco.',
};
